// Formatage partagé des champs client (saisie identique côté représentant et
// côté admin). Regroupé ici pour que la création d'un client se comporte partout
// de la même façon : téléphone et code postal masqués, provinces normalisées.

// Provinces et territoires du Canada — codes à 2 lettres.
export const PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];

/** Téléphone → (xxx) xxx-xxxx, formaté au fil de la saisie. */
export function formatTelephone(v: string): string {
  const d = v.replace(/\D/g, '').slice(0, 10);
  if (d.length <= 3) return d ? `(${d}` : '';
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** Code postal → H0H 0H0 (majuscules, espace après 3 caractères). */
export function formatCodePostal(v: string): string {
  const c = v.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
  return c.length > 3 ? `${c.slice(0, 3)} ${c.slice(3)}` : c;
}
